import { useMemo, useState } from 'react';
import { useGetConnectionPathsQuery } from '../../../../services/connectionPathsV2';

export function useConnectionPaths({ contact }) {
  const { data = [], isLoading, isSuccess } = useGetConnectionPathsQuery({ contactId: contact.id });
  const [showAll, setShowAll] = useState(false);

  const { initialCount, itemsToRender, hasMore } = useMemo(() => {
    const initial = Math.min(5, data.length);
    const visibleItems = showAll ? data : data.slice(0, initial);
    const more = data.length > initial;
    return { initialCount: initial, itemsToRender: visibleItems, hasMore: more };
  }, [data, showAll]);

  return {
    data: data ?? [],
    isLoading,
    isSuccess,
    showAll,
    setShowAll,
    initialCount,
    itemsToRender,
    hasMore,
  };
}
